import Swiper from 'swiper/dist/js/swiper';

new Swiper('.js-nearby-universities-swiper', { // eslint-disable-line
  spaceBetween: 30,
  slidesPerView: 4,
  simulateTouch: false,
  breakpoints: {
    992: {
      spaceBetween: 15,
      slidesPerView: 'auto',
      freeMode: false,
      pagination: {
        el: '.js-nearby-universities-swiper-pagination',
        clickable: true,
      },
    },
  },
});

if (QB.isMobile) {
  new Swiper('.js-related-posts-swiper', { // eslint-disable-line
    pagination: {
      el: '.js-swiper-related-posts-pagination',
      clickable: true,
    },
    onInit(swiper) {
      if (swiper.slides.length === 1) {
        $('.js-swiper-related-posts-pagination').hide();
      }
    },
  });
}
